var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../../core/runtime/src';
import { AUTO_EXPANDING_WIDTH, INITIAL_MIN_WIDTH, INITIAL_WIDTH, RESIZABLE_COLUMNS_ACTIVE_CLASS, RESIZABLE_COLUMNS_DRAGGING_CLASS } from './constants';
import ResizableColumnsUtils from './utils';
var ResizableColumnsHandler = /** @class */ (function () {
    function ResizableColumnsHandler(table, resizeSideEffect) {
        this.table = table;
        this.resizeSideEffect = resizeSideEffect;
        this.node = this.table.node;
        this.node = this.table.node;
        this.resizableColumnsUtils = new ResizableColumnsUtils(this.table);
        this.columnWidths = {};
        this.containerWidth = 0;
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onContainerChange = this.onContainerChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }
    ResizableColumnsHandler.prototype.addActiveClass = function (column) {
        var nextColumn = column.nextElementSibling;
        if (!this.draggedColumn && nextColumn) {
            nextColumn.classList.add(RESIZABLE_COLUMNS_ACTIVE_CLASS);
        }
    };
    ResizableColumnsHandler.prototype.removeActiveClass = function (column) {
        var nextColumn = column.nextElementSibling;
        if (!this.draggedColumn && nextColumn) {
            var id = nextColumn.getAttribute('data-awsui-column-id');
            this.resizableColumnsUtils.getColumnWithStickyHeader(id).forEach(function (element) {
                element.classList.remove(RESIZABLE_COLUMNS_ACTIVE_CLASS);
            });
        }
    };
    ResizableColumnsHandler.prototype.onMouseEnter = function (e) {
        this.addActiveClass(e.currentTarget.parentElement);
    };
    ResizableColumnsHandler.prototype.onMouseLeave = function (e) {
        this.removeActiveClass(e.currentTarget.parentElement);
    };
    ResizableColumnsHandler.prototype.onMouseDown = function (e) {
        var isLeftButton = e.button === 0;
        if (!isLeftButton) {
            return;
        }
        // Prevent a scroll selection. Otherwise, the scrollLeft won't work property in Safari
        e.preventDefault();
        // Make sure that the draggedColumn is always an original header column by getting a column id, which could be
        // from both the sticky header and the original header. Then, use it to find the original header column
        var awsuiTable = ResizableColumnsUtils.findClosestParent(e.currentTarget, 'awsui-table');
        var columnId = e.target.parentNode.getAttribute('data-awsui-column-id');
        var draggedColumn = awsuiTable.querySelector("table [data-awsui-column-id=\"" + columnId + "\"]");
        this.addActiveClass(draggedColumn);
        this.draggedColumn = draggedColumn;
        this.columnLeftEdge = this.resizableColumnsUtils.getEdgePosition(this.draggedColumn, 'left');
        this.prevColumnWidths = __assign({}, this.columnWidths);
        this.toggleDraggingStyles(true);
        this.toggleTracker(true);
    };
    ResizableColumnsHandler.prototype.onMouseUp = function () {
        if (this.draggedColumn) {
            var draggedColumn = this.draggedColumn;
            this.draggedColumn = null;
            this.hasBeenDragged = true;
            this.fireColumnWidthsChange();
            this.toggleTracker(false);
            this.toggleDraggingStyles(false);
            this.removeActiveClass(draggedColumn);
            window.clearInterval(this.autoExpandingIntervalId);
        }
    };
    ResizableColumnsHandler.prototype.fireColumnWidthsChange = function () {
        if (!this.resizableColumnsUtils.isEqualWidths(this.prevColumnWidths, this.columnWidths)) {
            var eventDetails = {
                widths: this.resizableColumnsUtils.getColumnWidths(this.columnWidths)
            };
            this.table.__fireEvent('columnWidthsChange', eventDetails);
        }
    };
    ResizableColumnsHandler.prototype.onClick = function (e) {
        // Prevent clicking on the sorting arrow
        if (this.hasBeenDragged) {
            e.stopPropagation();
            this.hasBeenDragged = false;
        }
    };
    ResizableColumnsHandler.prototype.onContainerChange = function (width) {
        // The width is always decimal number in IE, we need to round it down to be calculated correctly
        var nextWidth = Math.floor(this.resizableColumnsUtils.getStylePixel(width));
        var currentWidth = this.resizableColumnsUtils.getTableWidth(this.columnWidths);
        if (nextWidth > currentWidth) {
            this.resizableColumnsUtils.getTable().style.width = this.resizableColumnsUtils.setStylePixel(nextWidth);
            this.containerWidth = nextWidth;
        }
        else {
            this.recalculateTableWidth();
        }
    };
    ResizableColumnsHandler.prototype.updateColumnWidth = function (columnWidth, prevColumnWidth) {
        var table = this.resizableColumnsUtils.getTable();
        var columnMinWidth = this.resizableColumnsUtils.getStylePixel(this.draggedColumn.style.minWidth);
        var nextColumnWidth = Math.max(columnWidth, columnMinWidth);
        var nextTableWidth = table.offsetWidth + nextColumnWidth - prevColumnWidth;
        var isShrinking = nextColumnWidth < prevColumnWidth;
        this.columnWidths[this.draggedColumn.getAttribute('data-awsui-column-id')] = nextColumnWidth;
        // Don't set "width" property to the last column, since the last column
        // will pickup the remaining space automatically
        if (this.draggedColumn !== this.resizableColumnsUtils.getLastColumn()) {
            this.draggedColumn.style.width = this.resizableColumnsUtils.setStylePixel(nextColumnWidth);
        }
        var containerWidth = this.resizableColumnsUtils.getContainer().offsetWidth;
        if (isShrinking && nextTableWidth < containerWidth) {
            table.style.width = this.resizableColumnsUtils.setStylePixel(containerWidth);
        }
        else {
            table.style.width = this.resizableColumnsUtils.setStylePixel(nextTableWidth);
        }
        this.resizeSideEffect();
    };
    ResizableColumnsHandler.prototype.onMouseMove = function (e) {
        var _this = this;
        if (this.draggedColumn) {
            var container_1 = this.resizableColumnsUtils.getContainer();
            var tableRightEdge = this.resizableColumnsUtils.getEdgePosition(container_1, 'right');
            var columnRightEdge = this.resizableColumnsUtils.getEdgePosition(this.draggedColumn, 'right');
            var mouseX = e.pageX;
            window.clearInterval(this.autoExpandingIntervalId);
            if (mouseX > tableRightEdge && columnRightEdge >= tableRightEdge) {
                this.autoExpandingIntervalId = window.setInterval(function () {
                    _this.isAutoExpanding = true;
                    _this.updateColumnWidth(_this.draggedColumn.offsetWidth + AUTO_EXPANDING_WIDTH, _this.draggedColumn.offsetWidth);
                    container_1.scrollLeft += AUTO_EXPANDING_WIDTH;
                    _this.toggleTracker(true);
                }, 10);
            }
            else if (columnRightEdge <= tableRightEdge) {
                // In case of switching from auto-expanding without releasing the mouse, we need to read the new column left edge position
                if (this.isAutoExpanding) {
                    this.isAutoExpanding = false;
                    this.columnLeftEdge = this.resizableColumnsUtils.getEdgePosition(this.draggedColumn, 'left');
                }
                this.updateColumnWidth(Math.min(mouseX, tableRightEdge) - this.columnLeftEdge, this.draggedColumn.offsetWidth);
                // Prevent the new right column edge from going beyond the right edge of the table
                var newRightColumnEdgePos = Math.min(this.draggedColumn.offsetWidth + this.resizableColumnsUtils.getEdgePosition(this.draggedColumn, 'left'));
                if (newRightColumnEdgePos > tableRightEdge) {
                    this.updateColumnWidth(tableRightEdge - this.resizableColumnsUtils.getEdgePosition(this.draggedColumn, 'left'), this.draggedColumn.offsetWidth);
                }
            }
            this.toggleTracker(true);
        }
    };
    ResizableColumnsHandler.prototype.onPreferencesChange = function () {
        var _this = this;
        this.node.addEventListener('awsui:contentSelectionChange', function () {
            var tableWidth = _this.resizableColumnsUtils.getTableWidth(_this.columnWidths);
            _this.resizableColumnsUtils.getTable().style.width = _this.resizableColumnsUtils.setStylePixel(Math.max(tableWidth, _this.containerWidth));
            _this.setupColumns();
        });
    };
    ResizableColumnsHandler.prototype.toggleTracker = function (isDisplayed) {
        if (isDisplayed) {
            var trackerX = this.draggedColumn.offsetWidth + this.draggedColumn.offsetLeft;
            this.resizableColumnsUtils.getTracker().style.display = 'block';
            this.resizableColumnsUtils.getTracker().style.left = this.resizableColumnsUtils.setStylePixel(trackerX);
            this.setupTracker();
        }
        else {
            this.resizableColumnsUtils.getTracker().style.display = 'none';
        }
    };
    ResizableColumnsHandler.prototype.toggleDraggingStyles = function (isDisplayed) {
        if (isDisplayed) {
            document.body.classList.add(RESIZABLE_COLUMNS_DRAGGING_CLASS);
        }
        else {
            document.body.classList.remove(RESIZABLE_COLUMNS_DRAGGING_CLASS);
        }
    };
    ResizableColumnsHandler.prototype.setupColumns = function () {
        var _this = this;
        var columns = this.resizableColumnsUtils.getResizableColumns();
        this.table.columnDefinitions.forEach(function (columnDefinition) {
            // the "find" method can't be used here since it's not supported in IE
            var column = columns.filter(function (column) { return column.getAttribute('data-awsui-column-id') === columnDefinition.id; })[0];
            if (column) {
                var minWidth = _this.resizableColumnsUtils.getStylePixel(columnDefinition.minWidth) || INITIAL_MIN_WIDTH;
                var width = _this.columnWidths[columnDefinition.id] || columnDefinition.width;
                if (!width) {
                    if (column === _this.resizableColumnsUtils.getLastColumn()) {
                        width = minWidth;
                    }
                    else {
                        width = column.offsetWidth;
                    }
                }
                _this.columnWidths[columnDefinition.id] = Math.max(minWidth, width);
                column.style.width = _this.resizableColumnsUtils.setStylePixel(_this.columnWidths[columnDefinition.id]);
                column.style.minWidth = _this.resizableColumnsUtils.setStylePixel(minWidth);
                // We don't set the width property to the last column to make it automatically fill the remaining space
                if (column === _this.resizableColumnsUtils.getLastColumn()) {
                    column.style.width = '';
                }
            }
            else {
                var width = _this.columnWidths[columnDefinition.id] || columnDefinition.width || INITIAL_WIDTH;
                _this.columnWidths[columnDefinition.id] = width;
            }
        });
    };
    ResizableColumnsHandler.prototype.setupTable = function () {
        // In Safari, the tableLayout needs to be set after setting the table width, otherwise, it won't work
        // @see https://codepen.io/anon/pen/eQKmba?editors=1010
        var currentWidth = this.resizableColumnsUtils.getTableWidth(this.columnWidths, true);
        var table = this.resizableColumnsUtils.getTable();
        table.style.width = this.resizableColumnsUtils.setStylePixel(currentWidth);
        table.style.tableLayout = 'fixed';
    };
    ResizableColumnsHandler.prototype.setupTracker = function () {
        var thead = this.resizableColumnsUtils.getThead();
        var tracker = this.resizableColumnsUtils.getTracker();
        tracker.style.top = this.resizableColumnsUtils.setStylePixel(thead.offsetHeight);
    };
    ResizableColumnsHandler.prototype.recalculateTableWidth = function () {
        var _this = this;
        AwsUi.elementQueries.requestAnimationFrame(function () {
            if (!_this.resizableColumnsUtils.getTable()) {
                return;
            }
            _this.columnWidths = {};
            _this.setupColumns();
            _this.setupTable();
        });
    };
    ResizableColumnsHandler.prototype.attach = function () {
        var _this = this;
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
        document.addEventListener('click', this.onClick, true);
        // Wait until the table is re-rendered before setting up the resizable columns.
        // It's necessary in case of the "resizableColumns" property is changed. The table
        // calls this "attach" method before re-rendering the table
        AwsUi.elementQueries.requestAnimationFrame(function () {
            if (!_this.resizableColumnsUtils.getTable()) {
                return;
            }
            _this.setupColumns();
            _this.setupTracker();
            _this.onPreferencesChange();
            _this.setupTable();
        });
    };
    ResizableColumnsHandler.prototype.detach = function () {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        document.removeEventListener('click', this.onClick);
        this.resizableColumnsUtils.getTable().style.tableLayout = '';
    };
    return ResizableColumnsHandler;
}());
export default ResizableColumnsHandler;
//# sourceMappingURL=handler.js.map